// SAMPLE POLICIES for prototype review — final policies require owner approval.

export const policiesNotice =
  "Sample policies for prototype review — final policies require owner approval.";

export const policies = [
  {
    id: "booking",
    title: "Booking",
    body: "All appointments are requested online through the booking page. Your spot is reserved once your deposit is received and your request is confirmed.",
  },
  {
    id: "deposits",
    title: "Deposits",
    body: "A deposit is required to secure every appointment. Deposits are applied toward your total service price and are non-refundable.",
  },
  {
    id: "cancellations",
    title: "Cancellations",
    body: "Please cancel at least 48 hours before your appointment. Cancellations made with less notice may forfeit the deposit.",
  },
  {
    id: "rescheduling",
    title: "Rescheduling",
    body: "Appointments may be rescheduled once with at least 48 hours notice, subject to availability. Your deposit will carry over to the new date.",
  },
  {
    id: "late-arrivals",
    title: "Late Arrivals",
    body: "Please arrive on time. A grace period may apply, after which the appointment may need to be shortened or rescheduled and a late fee may apply.",
  },
  {
    id: "no-shows",
    title: "No-Shows",
    body: "Clients who miss an appointment without notice forfeit their deposit and may be required to prepay in full for future bookings.",
  },
  {
    id: "hair-preparation",
    title: "Hair Preparation",
    body: "Arrive with hair washed, blow-dried, fully detangled, and free of heavy product unless your service notes say otherwise.",
  },
  {
    id: "hair-included",
    title: "Hair Included",
    body: "Styles marked “Hair Included” include standard braiding hair in select colors. Specialty colors or textures may require you to supply hair or pay an additional fee.",
  },
  {
    id: "guests",
    title: "Guests",
    body: "To keep appointments comfortable and on schedule, extra guests are discouraged unless arranged in advance.",
  },
  {
    id: "children",
    title: "Children",
    body: "Children are welcome for their own appointments. A parent or guardian must remain reachable for the duration of a child's service.",
  },
  {
    id: "remaining-balance",
    title: "Remaining Balance",
    body: "The remaining balance is due at your appointment. Accepted payment methods will be confirmed when your appointment is approved.",
  },
  {
    id: "appointment-location",
    title: "Appointment Location",
    body: "Appointments take place in Hampton, Virginia. The exact appointment location will be provided to confirmed clients only.",
  },
];

